<template>
    <v-container fluid v-if="this.$store.state.signedIn">
        <v-flex xs12 class="px-4 py-4">
            <v-card>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        BGP Spotlight Polling API
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-flex class="px-2 py-2">
                        <v-card>
                            <v-toolbar color="accent">
                                <v-toolbar-title :style="$store.state.textFormatting.headers">
                                    What is the API for?
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <h2 :style="$store.state.textFormatting.main"> The BGP Spotlight polling API allows users to poll for alerts which have been generated for their organisation, without having to access the website. </h2>
                                <h2 :style="$store.state.textFormatting.main"> The system will store alerts (up to 5000, first in first out), and each time an alert is polled for, it is then deleted. You can therefore have multiple systems accessing the API and there will be no duplicate alerts pulled.</h2>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <v-flex class="px-2 py-2">
                        <v-card>
                            <v-toolbar color="accent">
                                <v-toolbar-title :style="$store.state.textFormatting.headers">
                                    The way it works
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <h2 :style="$store.state.textFormatting.main"> An alert is created from the system, from either your <v-btn :style="$store.state.textFormatting.main" @click="routeNewWindow('ASN Settings')" color="success" small> ASNs </v-btn> or <v-btn :style="$store.state.textFormatting.main" @click="routeNewWindow('Restricted Prefix Settings')" color="success" small> Prefixes </v-btn> (<b>NOTE:</b> This currently only works for <b>organisation</b> defined ASNs / Prefixes). </h2>
                                <h2 :style="$store.state.textFormatting.main"> The alert is stored in the polling system for quick access via the API. </h2>
                                <h2 :style="$store.state.textFormatting.main"> User polls for alerts, all of which are then deleted out of the polling system (<b>not the main system, this will remain unaffected</b>) - see the example <v-btn small color="success" :style="$store.state.textFormatting.main" @click="downloadFile"> <v-icon>save_alt</v-icon> Python script</v-btn> for a quick rundown of how to use the tool. </h2>
                            </v-card-text>
                        </v-card>
                    </v-flex>

                    <v-flex class="px-2 py-2">
                        <v-card>
                            <v-toolbar color="accent">
                                <v-toolbar-title :style="$store.state.textFormatting.headers">
                                    Polling API endpoints explained
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <p :style="$store.state.textFormatting.main"> <b>AUTH:</b> Takes your login credentials and returns an access token for the other endpoints. The only unauthenticated endpoint </p>
                                <v-divider /><br />
                                <p :style="$store.state.textFormatting.main"> <b>INFO:</b> Provides info (similar to what you see on this page). </p>
                                <p :style="$store.state.textFormatting.main"> <b>ACTIVATE:</b> This will activate your organisation for polling, begin the storage of alerts on the intermediary service </p>
                                <p :style="$store.state.textFormatting.main"> <b>POLL:</b> Poll for alerts, you can specify and amount of alerts via 'NUM_ALERTS' header. The alerts polled will be deleted from the intermediary service. There is a function in the example script to format the alerts to JSON. </p>
                                <p :style="$store.state.textFormatting.main"> <b>STATUS:</b> Returns the status of the queue. Note there will be at most 5000 alerts in the queue (though it may peak above 5000 at times). </p>
                                <p :style="$store.state.textFormatting.main"> <b>DEACTIVATE:</b> Deactivates polling for your organisation, deleting the remaining queue and stopping all additional polling. </p>
                                <p :style="$store.state.textFormatting.main"> <b>FLUSH:</b> Clears all alerts from the intermediary service, meaning only NEW alerts will be in the queue when you poll again. </p>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-card-text>
            </v-card>
            <br />
        </v-flex>
    </v-container>
</template>

<script>

import sometext from 'raw-loader!../utils/example_poll.txt';

export default {
  name: 'pollapi',
  components: {  },
  data () {
    return {
        /*example_script: {
            title: 'example_poll.py',
            loc: require('../utils/example_poll.py')
        },*/
        fileloc: '../utils/example_poll.txt',
        text: sometext
    };
  },
  mounted () {
  },
  beforeMount() {  
  },
  methods: {
    routeNewWindow: async function (input) {
        let routeData = this.$router.resolve({name: input});
        window.open(routeData.href, '_blank');
    },
    downloadFile: async function () {
        const url = window.URL.createObjectURL(
            new Blob([this.text])
        )
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'example_poll.py')
        document.body.appendChild(link)
        link.click()
    }
    
  }
};
</script>
